import { Box, Plus } from 'lucide-react';

interface ClientConnectorsProps {
  clientId: string;
}

export function ClientConnectors({ clientId: _clientId }: ClientConnectorsProps) {
  // TODO: Implement connector management
  // - Fetch connectors via GET /api/portal/clients/{id}/connectors
  // - Configure connector via POST /api/portal/clients/{id}/connectors
  // - Display connector status, test connection

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-slate-100">Connectors</h2>
          <p className="mt-1 text-sm text-slate-400">Manage Odoo and other ERP connectors</p>
        </div>
        <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 transition-all">
          <Plus className="h-4 w-4 mr-2" />
          Add Connector
        </button>
      </div>

      {/* Placeholder */}
      <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg border border-slate-700 p-12 text-center">
        <Box className="mx-auto h-12 w-12 text-slate-600" />
        <h3 className="mt-2 text-sm font-semibold text-slate-300">Connector management coming soon</h3>
        <p className="mt-1 text-sm text-slate-500">
          This feature will be implemented in Phase 7
        </p>
      </div>
    </div>
  );
}
